import API from '../stores/API'
import { FleetItem } from '../stores/Fleet/index.d'
import { Registration } from '../stores/RegistrationCard/index.d'
import { Sample } from '../stores/Sample/index.d'

export interface DashboardFilters {
  sites?: number[]
  fleetLimit?: number
  sampleLimit?: number
  registrationLimit?: number
}

export interface DashboardResponse {
  fleet: FleetItem[]
  notNormalSamples: Sample[]
  samplesInProgress: Registration[]
}

export const dashboardApi = {
  getDashboard: async (filters: DashboardFilters = {}): Promise<DashboardResponse> => {
    const response = await API.get('/dashboard', { params: filters })
    return response.data
  }
}

export default dashboardApi
